import script from "./SurveySection.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveySection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__